import { initSimpleTooltips } from "@plugins";
import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => {
    initSimpleTooltips(".js-cart-button");
});

window.addEventListener("load", initSimpleTooltips(".js-cart-button"));
